import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileSave = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_15_7888",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 20,
		height: 20,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_15_7888)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M15.0018 17.2035L18.0387 14.1667L17.1685 13.2965L15.6268 14.8381V11.0625H14.3768V14.8381L12.8351 13.2965L11.9649 14.1667L15.0018 17.2035ZM11.8768 19.7917V18.5417H18.1268V19.7917H11.8768ZM5.04992 16.4583C4.63964 16.4583 4.28603 16.3098 3.98908 16.0127C3.692 15.7158 3.54346 15.3622 3.54346 14.9519V3.38146C3.54346 2.97118 3.692 2.61757 3.98908 2.32063C4.28603 2.02354 4.63964 1.875 5.04992 1.875H10.8351L15.6268 6.66667V9.23562H14.3768V7.29167H10.2101V3.125H5.04992C4.98575 3.125 4.927 3.15174 4.87367 3.20521C4.82019 3.25854 4.79346 3.31729 4.79346 3.38146V14.9519C4.79346 15.016 4.82019 15.0748 4.87367 15.1281C4.927 15.1816 4.98575 15.2083 5.04992 15.2083H10.0499V16.4583H5.04992Z",
			fill: "#152A58"
		})
	})]
});
export default SvgFileSave;
